var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{class:_vm.$style.container,attrs:{"width":"100","height":"100","viewBox":"0 0 100 100"}},[_c('circle',{class:_vm.$style.meter,attrs:{"cx":"50","cy":"50","r":_vm.radius,"stroke-width":"10"}}),_c('circle',{class:_vm.$style.value,style:({
    strokeDasharray: _vm.dashArray,
  }),attrs:{"cx":"50","cy":"50","r":_vm.radius,"stroke-width":"10"}})])}
var staticRenderFns = []

export { render, staticRenderFns }